/* istanbul ignore file */

import { parse } from 'querystring';
import React from 'react';
import { withRouter } from 'react-router';
import { matchPath } from 'react-router-dom';
import { Route, Switch } from 'react-router';
import { getIn } from 'seamless-immutable';
import Skin from '@catalogo/theme-skin';
import PreRender from '@catalogo/core-pre-render';
import routes from '@catalogo/shell-web/src/routes';
import Debugger from '@catalogo/core-debugger';
import PropTypes from 'prop-types';
import Modal from '@catalogo/core-modal';
import { RenderHeaderTestAB, RenderFooterTestAB } from '@catalogo/core-header';

class App extends React.Component {
  async componentDidUpdate(prevProps) {
    const { history } = this.getRouteProps();
    if (history.action === 'PUSH') {
      window.scrollTo(0, 0);
    }
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  getRouteProps() {
    const { history } = this.props;
    const url = this.getUrl();
    const { pathname } = this.props.location;
    const route = routes.find(route => matchPath(pathname, route));
    const match = matchPath(pathname, route);
    const parsedQs = parse(getIn(history, ['location', 'search'], '').replace('?', ''));

    return { url, match, route, history, parsedQs };
  }

  getUrl() {
    const { location } = this.props;
    return location.pathname + location.search;
  }

  render() {
    const routeProps = this.getRouteProps();
    return (
      <PreRender>
        <Skin>
          <RenderHeaderTestAB routeProps={routeProps} />
          <Switch>
            {routes.map(route => (
              <Route {...route} {...routeProps} key={route.path} />
            ))}
          </Switch>
          <Modal {...routeProps} />

          <RenderFooterTestAB routeProps={routeProps} />
          <Debugger parsedQs={routeProps.parsedQs} />
        </Skin>
      </PreRender>
    );
  }
}

App.propTypes = {
  store: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
  client: PropTypes.object,
};

export default withRouter(App);
